export const environment = {
    production: false,
    // apiURL: 'https://devcrminternalapi.56-north.com/',

    /*API GATEWAY URL*/
    apiURL: "https://devcrminternalapims.56-north.com/",
};
